import React from 'react';
import {ALIS, SATIS} from "../constants";
import {calculateItem} from "../commons";

class ItemUnit extends React.Component {

    state = {
        katsayi: 1,
        kusurat_aktif: true,
        kusurat: 0,
        ekleme_aktif: true,
        ekleme: 0,
        asagi_yuvarla: false,
        yukari_yuvarla: false,
        tam_yuvarla: false,
        sonucu_carp: 1,
        devre_disi: false,
        diger_hesaplanana_ekle: 0,
        sonuc_x_in_kati: null
    }

    componentWillMount() {
        const {data, name, type} = this.props;
        if (data && data[name] && data[name][type]) {
            this.setState({...data[name][type]})
        }
    }

    componentWillReceiveProps(nextProps) {
        if (this.props.data !== nextProps.data) {
            if (nextProps.data && nextProps.data[nextProps.name] && nextProps.data[nextProps.name][nextProps.type]) {
                this.setState({...nextProps.data[nextProps.name][nextProps.type]})
            }
        }
    }

    changeValue = (key, value) => {
        let temp = {}
        if (key === 'asagi_yuvarla') {
            if (this.state.asagi_yuvarla && !value) {
                temp = {asagi_yuvarla: false}
            } else {
                temp = {asagi_yuvarla: value, yukari_yuvarla: !value}
            }
        } else if (key === 'yukari_yuvarla') {
            if (this.state.yukari_yuvarla && !value) {
                temp = {yukari_yuvarla: false}
            } else {
                temp = {asagi_yuvarla: !value, yukari_yuvarla: value}
            }
        } else {
            temp = {[key]: value}
        }
        this.setState({...this.state, ...temp}, this.onChange)
    }

    onChange = () => {
        const {data, name, type} = this.props;
        if (this.state.devre_disi) {
            let otherType = type === ALIS ? SATIS : ALIS
            this.props.onChange({...data[name], [type]: {...this.state}, [otherType]: {...data[name][otherType], devre_disi: false}})
        } else {
            this.props.onChange({...data[name], [type]: {...this.state}})
        }
    }

    renderCalculateInputs = () => {
        const {hasAltin, type, data, name} = this.props;

        if (this.state.devre_disi) {
            return null
        }

        return (
            <React.Fragment>
                <table>
                    <tbody>
                    <tr>
                        <td>Has altın {type === ALIS ? 'alış' : 'satış'} fiyatını</td>
                        <td><input type="number" style={{margin: '0 10px'}} value={this.state.katsayi} onChange={(e) => {
                            this.changeValue('katsayi', e.target.value)
                        }} placeholder="kat sayı"/></td>
                        <td>ile çarp.</td>
                    </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                    <tr>
                        <td>küsürat</td>
                        <td><input type="checkbox" style={{margin: '0 -5px 0 10px'}} checked={this.state.kusurat_aktif} onChange={(e) => {
                            this.changeValue('kusurat_aktif', e.target.checked)
                        }}/></td>
                        <td><input type="number" style={{margin: '0 10px'}} placeholder="küsürat" value={this.state.kusurat} onChange={(e) => {
                            this.changeValue('kusurat', e.target.value)
                        }}/></td>
                        <td>sayısından küçükse</td>
                        <td><input type="checkbox" style={{margin: '0 -5px 0 10px'}} checked={this.state.ekleme_aktif} onChange={(e) => {
                            this.changeValue('ekleme_aktif', e.target.checked)
                        }}/></td>
                        <td><input type="number" style={{margin: '0 10px'}} placeholder="miktar" value={this.state.ekleme} onChange={(e) => {
                            this.changeValue('ekleme', e.target.value)
                        }}/></td>
                        <td>ekle.</td>
                    </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                    <tr>
                        <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.asagi_yuvarla} onChange={(e) => {
                            this.changeValue('asagi_yuvarla', e.target.checked)
                        }}/></td>
                        <td>AŞAĞI ,</td>
                        <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.yukari_yuvarla} onChange={(e) => {
                            this.changeValue('yukari_yuvarla', e.target.checked)
                        }}/></td>
                        <td>YUKARI ,</td>
                        <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.tam_yuvarla} onChange={(e) => {
                            this.changeValue('tam_yuvarla', e.target.checked)
                        }}/></td>
                        <td>TAM yuvarla</td>
                    </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                    <tr>
                        <td>Sonucu</td>
                        <td><input type="number" style={{margin: '0 10px'}} value={this.state.sonucu_carp} onChange={(e) => {
                            this.changeValue('sonucu_carp', e.target.value)
                        }}/></td>
                        <td>ile çarp.</td>
                    </tr>
                    </tbody>
                </table>
                <table>
                    <tbody>
                    <tr>
                        <td>Sonucu</td>
                        <td><input type="number" style={{margin: '0 10px'}} value={this.state.sonuc_x_in_kati} onChange={(e) => {
                            this.changeValue('sonuc_x_in_kati', e.target.value)
                        }}/></td>
                        <td>ve katlarına yuvarla</td>
                    </tr>
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

    renderDisableInputs = () => {
        const {hasAltin, type, data, name} = this.props;

        if (!this.state.devre_disi) {
            return null
        }

        return (
            <React.Fragment>
                <table>
                    <tbody>
                    <tr>
                        <td>Hesaplanan {type === ALIS ? 'satış' : 'alış'} fiyatına</td>
                        <td><input type="number" style={{margin: '0 10px'}} value={this.state.diger_hesaplanana_ekle} onChange={(e) => {
                            this.changeValue('diger_hesaplanana_ekle', e.target.value)
                        }} placeholder="miktar"/></td>
                        <td>ekle.</td>
                    </tr>
                    </tbody>
                </table>
            </React.Fragment>
        )
    }

    render() {
        const {hasAltin, type, data, name} = this.props;
        return (
            <td style={{width: '47.5%'}} className="box_inset">
                <div className={type === ALIS ? 'left_col' : 'right_col'}>
                    <h3>Has altın {type === ALIS ? 'Alış' : 'Satış'} (<span>{(parseFloat(hasAltin[type]) + parseFloat(data.has_altin[type + '_ekleme'])).toFixed(2)}</span>)</h3>
                    <table>
                        <tbody>
                        <tr style={{color: 'indianred'}}>
                            <td><input type="checkbox" style={{margin: '0 10px'}} checked={this.state.devre_disi} onChange={(e) => {
                                this.changeValue('devre_disi', e.target.checked)
                            }}/></td>
                            <td>Hesaplamayı devre dışı bırak</td>
                        </tr>
                        </tbody>
                    </table>
                    {this.renderCalculateInputs()}
                    {this.renderDisableInputs()}
                </div>
                <hr/>
                <span className="result">Sonuç = <span>{calculateItem(hasAltin, data, type, name)}</span></span>
            </td>
        );
    }
}

export default ItemUnit


// WEBPACK FOOTER //
// ./src/component/ItemUnit.js